// frontend/src/utils/statusOptions.js
export const getStatusOptions = (mediaType) => {
  switch (mediaType) {
    case 'Anime':
    case 'AnimeMovie':
    case 'AnimeSerie':
    case 'TV':
    case 'ScreenMedia':
      return ['Finished', 'Watching', 'Dropped', 'Forgotten', 'On Hold', 'Plan to Watch'];
    case 'Movie':
      return ['Finished', 'Plan to Watch'];
    case 'Manga':
      return ['Reading', 'Dropped', 'On Hold', 'Forgotten', 'Plan to Read', 'Finished'];
    case 'SteamGame':
    case 'PhysicalGame':
    case 'PSPGame':
    case 'NDSGame':
    case 'GameboyGame':
    case 'SwitchGame':
    case 'PS3Game':
    case 'VitaGame':
      return ['Completed', 'Playing', 'Not Playing', 'Forgotten', 'Unplayed', 'Dropped'];
    case 'Music':
    case 'Vinyl':
    case 'CD':
      return ['Listened', 'Not Listened'];
    default:
      return ['Unknown'];
  }
};

export const getOwnershipOptions = (mediaType) => {
  switch (mediaType) {
    case 'Manga':
      return ['Not Owned', 'Wishlisted', 'Collecting', 'Owned'];
    case 'PhysicalGame':
    case 'PSPGame':
    case 'NDSGame':
    case 'GameboyGame':
    case 'SwitchGame':
    case 'PS3Game':
    case 'VitaGame':
    case 'Music':
    case 'Vinyl':
    case 'CD':
      return ['Not Owned', 'Wishlisted', 'Owned'];
    default:
      return [];
  }
};